import React, { useState, useEffect } from 'react'
import {
  createCron,
  deleteCronById,
  getCommands,
  getCronExecutionsById,
  getCronJobs,
  updateCronById
} from '../services/cron'
import { getPortugueseValueCron } from '../helpers/Cron'
const cronstrue = require('cronstrue/i18n')

const Cron = () => {
  const [cronJobs, setCronJobs] = useState([])
  const [selectedCron, setSelectedCron] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [actions, setActions] = useState([])
  const [cronExecutions, setCronExecutions] = useState([])

  // Form state
  const [formData, setFormData] = useState({
    name: '',
    minute: '*',
    hour: '*',
    dayOfMonth: '*',
    month: '*',
    dayOfWeek: '*',
    description: ''
  })

  // Load sample data on first render
  useEffect(() => {
    getCronJobs().then((c) => {
      setCronJobs(c)
    })
    getCommands().then((ca) => {
      setActions(ca)
    })
  }, [])

  useEffect(() => {
    if (selectedCron) {
      getCronExecutionsById(selectedCron._id).then((exec) => {
        setCronExecutions(exec)
      })
    }
  }, [selectedCron])

  // Parse cron expression into parts
  const parseCronExpression = (expression) => {
    const parts = expression.split(' ')
    return {
      minute: parts[0],
      hour: parts[1],
      dayOfMonth: parts[2],
      month: parts[3],
      dayOfWeek: parts[4]
    }
  }

  // Handle cron job selection
  const handleSelectCron = (cron) => {
    setSelectedCron(cron)
    setIsEditing(false)

    const cronParts = parseCronExpression(cron.cronTime)
    setFormData({
      ...cron,
      ...cronParts
    })
  }

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
  }
  const generateCronPTExpression = () => {
    try {
      return cronstrue.toString(generateCronExpression(), { locale: 'pt_BR' })
    } catch (error) {
      console.error(error)
    }
  }
  // Generate cron expression from form data
  const generateCronExpression = () => {
    return `${formData.minute} ${formData.hour} ${formData.dayOfMonth} ${formData.month} ${formData.dayOfWeek}`
  }

  // Save cron job (create or update)
  const handleSaveCron = () => {
    const cronExpression = generateCronExpression()
    const cronData = {
      name: formData.name,
      cronTime: cronExpression,
      exec: formData.exec,
      description: formData.description
    }

    if (selectedCron && isEditing) {
      updateCronById(selectedCron._id, cronData).then((res) => {
        const updatedJobs = cronJobs.map((job) => (job._id === selectedCron._id ? { ...job, ...cronData } : job))
        setCronJobs(updatedJobs)
        setSelectedCron(res)
      })
    } else {
      // Create new cron
      createCron(cronData).then((d) => {
        setCronJobs([...cronJobs, d])
        setSelectedCron(d)
      })
    }

    setIsEditing(false)
  }

  // Delete selected cron job
  const handleDeleteCron = () => {
    if (selectedCron) {
      deleteCronById(selectedCron._id).then(() => {
        setCronJobs(cronJobs.filter((job) => job._id !== selectedCron._id))
        setSelectedCron(null)
        resetForm()
      })
    }
  }

  // Reset form to default values
  const resetForm = () => {
    setFormData({
      name: '',
      minute: '*',
      hour: '*',
      dayOfMonth: '*',
      month: '*',
      dayOfWeek: '*',
      description: '',
      enabled: true
    })
  }

  // Start creating a new cron job
  const handleNewCron = () => {
    setSelectedCron(null)
    setIsEditing(true)
    resetForm()
  }

  // Start editing selected cron job
  const handleEditCron = () => {
    setIsEditing(true)
  }

  // Cancel editing
  const handleCancelEdit = () => {
    if (selectedCron) {
      const cronParts = parseCronExpression(selectedCron.cronTime)
      setFormData({
        ...selectedCron,
        ...cronParts,
        description: selectedCron.description || ''
      })
    } else {
      resetForm()
    }
    setIsEditing(false)
  }

  // Format cron expression for display
  const formatCronForDisplay = (cronExpression) => {
    return (
      <div className="cron-display p-2 border rounded">
        <strong>{cronstrue.toString(cronExpression, { locale: 'pt_BR' })}</strong>
      </div>
    )
  }

  return (
    <div className="container mt-4">
      <h1 className="mb-4">Cron: Serviços Automáticos</h1>

      <div className="row">
        {/* Cron Jobs List */}
        <div className="col-md-5">
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Minhas tarefas agendadas</h5>
              <button className="btn btn-sm btn-primary" onClick={handleNewCron}>
                <i className="bi bi-plus"></i> Agendar nova tarefa
              </button>
            </div>
            <div className="list-group list-group-flush">
              {cronJobs.length === 0 ? (
                <div className="list-group-item text-muted">Ainda não temos nenhum cron</div>
              ) : (
                cronJobs.map((cron) => (
                  <button
                    key={cron.id}
                    className={`list-group-item list-group-item-action ${
                      selectedCron?._id === cron._id ? 'active' : ''
                    }`}
                    onClick={() => handleSelectCron(cron)}
                  >
                    <div className="d-flex w-100 justify-content-between">
                      <h6 className="mb-1">{cron.name}</h6>
                    </div>
                    <small>{formatCronForDisplay(cron.cronTime)}</small>
                    {cron.description && <div className="mt-1 small">{cron.description}</div>}
                  </button>
                ))
              )}
            </div>
          </div>
        </div>

        {/* Cron Job Details/Form */}
        <div className="col-md-7">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">
                {selectedCron && !isEditing
                  ? selectedCron.name
                  : isEditing
                  ? selectedCron
                    ? 'Editando uma Rotina Cron'
                    : 'Criar uma nova rotina Cron'
                  : 'Selecione um Cron'}
              </h5>
            </div>

            <div className="card-body">
              {!selectedCron && !isEditing ? (
                <div className="text-muted">Selecione um cron ta barra ao lado ou crie um</div>
              ) : (
                <>
                  {isEditing ? (
                    <form>
                      <div className="mb-3">
                        <label htmlFor="action" className="form-label">
                          Selecione a Ação
                        </label>
                        <select
                          className="form-select"
                          id="exec"
                          name="exec"
                          value={formData.exec || ''}
                          onChange={handleInputChange}
                        >
                          <option value="">Escolha uma ação</option>
                          <option value="">------------</option>
                          {actions.map((action, index) => (
                            <option key={index} value={action}>
                              {getPortugueseValueCron(action)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label htmlFor="name" className="form-label">
                          Nome
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>

                      <div className="row g-3 mb-3">
                        <div className="col-md-6">
                          <label htmlFor="minute" className="form-label">
                            Minutos (0-59)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="minute"
                            name="minute"
                            value={formData.minute}
                            onChange={handleInputChange}
                            placeholder="*"
                          />
                          <small className="text-muted">Use * for any, comma separated values, or ranges (0-30)</small>
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="hour" className="form-label">
                            Hora (0-23)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="hour"
                            name="hour"
                            value={formData.hour}
                            onChange={handleInputChange}
                            placeholder="*"
                          />
                        </div>
                      </div>

                      <div className="row g-3 mb-3">
                        <div className="col-md-6">
                          <label htmlFor="dayOfMonth" className="form-label">
                            Dia do Mês (1-31)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="dayOfMonth"
                            name="dayOfMonth"
                            value={formData.dayOfMonth}
                            onChange={handleInputChange}
                            placeholder="*"
                          />
                        </div>

                        <div className="col-md-6">
                          <label htmlFor="month" className="form-label">
                            Mês (1-12)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="month"
                            name="month"
                            value={formData.month}
                            onChange={handleInputChange}
                            placeholder="*"
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label htmlFor="dayOfWeek" className="form-label">
                          Dias da semana (0-6)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="dayOfWeek"
                          name="dayOfWeek"
                          value={formData.dayOfWeek}
                          onChange={handleInputChange}
                          placeholder="*"
                        />
                        <small className="text-muted">0 = Sunday, 6 = Saturday</small>
                      </div>

                      <div className="mb-3">
                        <label htmlFor="description" className="form-label">
                          Descrição (Opcional)
                        </label>
                        <textarea
                          className="form-control"
                          id="description"
                          name="description"
                          rows="2"
                          value={formData.description}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="d-flex justify-content-between">
                        <button type="button" className="btn btn-secondary" onClick={handleCancelEdit}>
                          Cancelar
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleSaveCron}>
                          Salvar
                        </button>
                      </div>
                    </form>
                  ) : (
                    <div>
                      <div className="mb-3">
                        <p>{getPortugueseValueCron(selectedCron.exec)}</p>
                        Agendado para:
                        {formatCronForDisplay(selectedCron.cronTime)}
                      </div>
                      {selectedCron.description && (
                        <div className="mb-3">
                          <h6>Description</h6>
                          <p>{selectedCron.description}</p>
                        </div>
                      )}
                      <div className="d-flex justify-content-between">
                        <button className="btn btn-danger" onClick={handleDeleteCron}>
                          Delete
                        </button>
                        <button className="btn btn-primary" onClick={handleEditCron}>
                          Edit
                        </button>
                      </div>
                      {cronExecutions.length > 0 && (
                        <div className="mt-4">
                          <ul className="list-group">
                            {cronExecutions.map((execution) => {
                              const duration = new Date(execution.end) - new Date(execution.start)
                              const statusClass = execution.success ? 'text-success' : 'text-danger'
                              return (
                                <li key={execution._id} className="list-group-item">
                                  <div>
                                    <strong>Saída:</strong> {execution.output}
                                  </div>
                                  <div>
                                    <strong>Iniciado às:</strong> {new Date(execution.start).toLocaleString()}
                                  </div>
                                  <div>
                                    <strong>Duração:</strong> {duration} ms
                                  </div>
                                  <div>
                                    <strong>Status:</strong>{' '}
                                    <span className={statusClass}>{execution.success ? 'Success' : 'Failure'}</span>
                                  </div>
                                </li>
                              )
                            })}
                          </ul>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>

            {isEditing && (
              <div className="card-footer bg-light">
                <h6>Preview:</h6>
                <div className="alert alert-info mb-0">
                  <p>
                    <strong>Agendado para:</strong> {generateCronExpression()}
                  </p>
                  <p>
                    <strong>{generateCronPTExpression()}</strong>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cron
